import cn from 'classnames';
import React from 'react';

import {ITableReportColumnProps} from 'components/table-report/table-report-columns/table-report-columns';
import {ITableReportProps} from 'components/table-report/table-report-types';

import {CHILD_TYPES} from '../../table-row-drillup-content-constants';
import {TDrillUpRow} from '../../table-row-drillup-content-model';
import {ExpandableItem} from '../expandable-item/expandable-item';

interface IRowChildrenContainerProps {
    isOpen: boolean;
    isNestedChild?: boolean;
    fieldChildren: TDrillUpRow[];
    columnProps: ITableReportColumnProps;
    docId?: ITableReportProps['docId'];
    isRowLoading: boolean;
    setIsRowLoading: (isRowLoading: boolean) => void;
    isFirstLevel?: boolean;
}

export const RowChildrenContainer = ({
    isOpen,
    isNestedChild,
    fieldChildren,
    columnProps,
    docId,
    isRowLoading,
    setIsRowLoading,
    isFirstLevel,
}: IRowChildrenContainerProps) => {
    const getChildType = (child: TDrillUpRow) => {
        if (child?.docId && child?.templateCode) {
            return CHILD_TYPES.DOCUMENT;
        }

        if (child?.data) {
            return CHILD_TYPES.ROW;
        }

        if (child?.message) {
            return CHILD_TYPES.MESSAGE;
        }

        return '';
    };

    return (
        <div
            className={cn('row-children-container', {
                'no-visible': !isOpen,
            })}
        >
            <div>
                {fieldChildren?.map((child, index) => (
                    <ExpandableItem
                        fieldKey={index}
                        isNestedChild={isNestedChild}
                        field={child}
                        isLastChild={fieldChildren.length - 1 === index}
                        columnProps={columnProps}
                        docId={child?.docId || docId || null}
                        isRowLoading={isRowLoading}
                        setIsRowLoading={setIsRowLoading}
                        isFirstLevel={isFirstLevel}
                        childType={getChildType(child)}
                    />
                ))}
            </div>
        </div>
    );
};
